import { useTranslation } from 'react-i18next';

import { Link } from '../../../components/Link';
import { useExternalHomepageConfig } from '../../../hooks/useExternalHomepageConfig';
import { isRemix } from '../../../utils/ssrUtils';
import { FooterItem } from './types';

export const useShopNavigationItem = (className: string): FooterItem => {
  const { t } = useTranslation();
  const { getHomepageUrl } = useExternalHomepageConfig();

  return {
    title: t('navbar.shop', 'Shop'),
    isDropdown: true,
    list: [
      isRemix() ? (
        <Link className={`${className}__link`} to="/" key="home">
          {t('footer.navigation.home', 'Home')}
        </Link>
      ) : (
        <a className={`${className}__link`} key="home" href={getHomepageUrl()}>
          {t('footer.navigation.home', 'Home')}
        </a>
      ),
      isRemix() ? (
        <Link
          className={`${className}__link`}
          to="/destinations"
          key="destinations"
        >
          {t('footer.navigation.destinations', 'Destinations')}
        </Link>
      ) : (
        <a
          className={`${className}__link`}
          key="destinations"
          href={getHomepageUrl('/destinations')}
        >
          {t('footer.navigation.destinations', 'Destinations')}
        </a>
      ),
      <Link key="my_esim" className={`${className}__link`} to="/orders">
        {t('navbar.my_esim', 'My eSIM')}
      </Link>,
      <Link key="my_account" className={`${className}__link`} to="/my-account">
        {t('navbar.my_account', 'My Account')}
      </Link>,
    ],
  };
};
